import * as http from '@angular/common/http'
import * as ngCore from '@angular/core'
import * as errors from '@attain-apps/errors'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as me from '../../me'

import * as gql from './gql'

// TODO: this should be done through NgRx rather than all in a service

@ngCore.Injectable()
export class Api {
  /** @see {@link http.HttpClient} */
  private readonly _http = ngCore.inject(http.HttpClient)
  /** @see {@link me.Feature} */
  private readonly _meFeature = ngCore.inject(me.Feature)

  public uploadFile(file: File): rxjs.Observable<string> {
    const fileNameParts = file.name.split('.')
    const extension = fileNameParts[fileNameParts.length - 1]
    // TODO: come up with a more robust test that uses something from entities
    // (so that backend and frontend enforce the same requirements)
    if (!/(xls[a-z]?|pdf)/.test(extension)) {
      throw new errors.ValidationError({
        reason: `Unsupported upload file type.`,
        type: 'file',
        value: extension,
      })
    }
    return gql.queries.uploadRequest
      .execute({
        ...TypeAsserter.validate(
          this._meFeature.contexts.selectors.zoneContext.asSignal(),
          TypeAsserter.assertIsNotNullish,
        ),
        extension,
      })
      .pipe(
        rxjs.switchMap(({ fields, url }) => {
          const formData = new FormData()
          if (fields) {
            for (const k in fields) {
              formData.append(k, fields[k])
            }
          }
          // NOTE: this must appear last (at least for mocking, potentially also for S3)
          formData.append('file', file)
          return this._http.post(url, formData, { responseType: 'text' })
        }),
      )
  }
}
